/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  CreateContactRequestJobFromCampaignMutationRequest,
  CreateContactRequestJobFromCampaignMutationResponse,
  CreateContactRequestJobFromCampaign400,
  CreateContactRequestJobFromCampaign404,
} from '../types/CreateContactRequestJobFromCampaign'

function getCreateContactRequestJobFromCampaignUrl() {
  const res = {
    method: 'POST',
    url: `/api/v1/contact_request/campaign/` as const,
  }
  return res
}

/**
 * @description Create contact request job(s) from a campaign's targets.
 * For single-type campaigns, creates one job. For multi-type campaigns
 * without a sub_category_slug, groups companies by type and creates
 * one job per eligible subcategory.
 * @summary Create contact request job(s) from a campaign's targets
 * {@link /api/v1/contact_request/campaign/}
 */
export async function createContactRequestJobFromCampaign(
  data: CreateContactRequestJobFromCampaignMutationRequest,
  config: Partial<
    RequestConfig<CreateContactRequestJobFromCampaignMutationRequest>
  > & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateContactRequestJobFromCampaignMutationResponse,
    ResponseErrorConfig<
      | CreateContactRequestJobFromCampaign400
      | CreateContactRequestJobFromCampaign404
    >,
    CreateContactRequestJobFromCampaignMutationRequest
  >({
    method: 'POST',
    url: getCreateContactRequestJobFromCampaignUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
